import { render, staticRenderFns } from "./redPropagandaItem.vue?vue&type=template&id=4628770f&scoped=true&"
import script from "./redPropagandaItem.vue?vue&type=script&lang=js&"
export * from "./redPropagandaItem.vue?vue&type=script&lang=js&"
import style0 from "./redPropagandaItem.vue?vue&type=style&index=0&id=4628770f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628770f",
  null
  
)

export default component.exports